import { React, useState} from 'react'
import Logo from "../../Reutilizables/Logo"
import MenuInicioSuscrito from "../../pages/inicioSuscrito/MenuInicioSuscrito"
import Data from './Data';
import ListaArticulos from "./ListaArticulos"
import BotonesLista from "./BotonesLista"
import "../../../styles/registrado/blog/blog.css"
import Footer from '../../Reutilizables/Footer';

function Blog() {

  const allCategories = [
		'TODO',
		...new Set(Data.map(article => article.category)),
	];

	const [categories] = useState(allCategories);
	const [articles, setArticles] = useState(Data);

	const filterCategory = (category) => {
		if (category === 'TODO'){
			setArticles(Data)
			return
		}

		const filteredData = Data.filter(article => article.category === category);
		setArticles(filteredData)
	}

  return (
    <div className='body-blog'>
      <div className='container-logo-menu-login'> 
    	  <Logo />
        <MenuInicioSuscrito />
      </div>
      <BotonesLista categories={categories} filterCategory={filterCategory}/>
		<ListaArticulos articles={articles}/>
      <Footer />
    </div>
  )
}

export default Blog